<common-mojo-card>
  <div class="details-container">
    <header class="center-header">
      <div class="row">
        <div class="col-auto mr-auto">
          <h1
            class="mat-headline-5 description-header"
            data-cy="candidate-details-card-title"
          >
            Details
          </h1>
        </div>
        <div class="col-auto">
          <a
            [routerLink]="['', { outlets: { modal: ['candidateDetails', candidate?.id] } }]"
            [skipLocationChange]="true"
            *mojoHasPrivilege="privileges.candidates.edit"
            class="btn btn-link"
            data-cy="candidate-details-card-edit-link"
          >
            <mat-icon>edit</mat-icon>
          </a>
        </div>
      </div>
    </header>
    <div class="row">
      <section
        class="col-xl-3 unset-section-border"
        data-cy="candidate-details-card-created-by-name"
      >
        <mojo-common-definition-list
          [colSize]="colSize"
          title="Created by"
        >
          <ng-container
            [ngTemplateOutlet]="defaultSourceNote"
            [ngTemplateOutletContext]="{data: candidate.createdByName}"
          >
          </ng-container>
        </mojo-common-definition-list>
      </section>
      <section
        class="col-xl-3"
        data-cy="candidate-details-card-created-date"
      >
        <mojo-common-definition-list
          [colSize]="colSize"
          title="Created on"
        >
          <span *ngIf="!!candidate?.createdDate; else emptyField">
            {{ candidate.createdDate | date: 'shortDate' }}
          </span>
        </mojo-common-definition-list>
      </section>
      <section
        class="col-xl-3"
        data-cy="candidate-details-card-source"
      >
        <mojo-common-definition-list
          [colSize]="colSize"
          title="Source"
        >
          <ng-container
            [ngTemplateOutlet]="defaultSourceNote"
            [ngTemplateOutletContext]="{data: candidate.source}"
          >
          </ng-container>
        </mojo-common-definition-list>
      </section>
      <section
        class="col-xl-3"
        data-cy="candidate-details-card-source-note"
      >
        <mojo-common-definition-list
          [colSize]="colSize"
          title="Source notes"
        >
          <ng-container
            [ngTemplateOutlet]="defaultSourceNote"
            [ngTemplateOutletContext]="{data: candidate.sourceNote}"
          >
          </ng-container>
        </mojo-common-definition-list>
      </section>
    </div>
    <ng-template
      #defaultSourceNote
      let-data='data'
    >
      <span *ngIf="!!data; else emptyField">
        {{ data }}
      </span>
    </ng-template>
    <ng-template #emptyField>
      <span class="grey-out">
        NA
      </span>
    </ng-template>
  </div>
</common-mojo-card>
